import Model from "../classes/Model";
import DirectionApi from "../classes/api/Direction";
import ValidationError from "../classes/ValidationError";
import DirectionShow from "./DirectionShow";

export default class Direction extends Model {

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get content() {
        return this._content;
    }
    set content(value) {
        this._content = value;
    }

    get shows() {
        return this._shows;
    }
    set shows(value) {
        this._shows = value;
    }

    get salary_scheme_id() {
        return this._salary_scheme_id;
    }
    set salary_scheme_id(value) {
        this._salary_scheme_id = value;
    }

    get isArchive() {
        return this._isArchive;
    }
    set isArchive(value) {
        this._isArchive = value;
    }

    get isShowSite() {
        return this._isShowSite;
    }
    set isShowSite(value) {
        this._isShowSite = value;
    }

    get id() {
        return this._id;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            name: this.name,
            salary_scheme_id: this.salary_scheme_id,
            content: this.content,
            shows: this.shows.map(show => show.id),
            is_archive: this.isArchive ? 1 : 0,
            is_show_site: this.isShowSite ? 1 : 0,
        };
    }

    static toResponse(data) {

        let shows = [];
        if (undefined !== data.shows && data.shows) {
            for (let show of data.shows) {
                shows.push(new DirectionShow(DirectionShow.toResponse(show)));
            }
        }
        return {
            id: data.id,
            name: data.name,
            salary_scheme_id: data.salary_scheme_id,
            content: data.content,
            shows: shows,
            isArchive: data.is_archive,
            isShowSite: data.is_show_site,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = []) {
        return DirectionApi.getList(page, perPage, sort, extraFields).then((response) => {
            let data = [];
            for (let trainer of response.data) {
                data.push(new this(this.toResponse(trainer)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return DirectionApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return DirectionApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Direction(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return DirectionApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}